import ClientBase from "../ClientBase";

const BASE_URL = "api/v1/modelgenconfig";

// Versioned, per-capture-type model-generation (FlowEngine) settings. Duallo-admin only.
class DualloModelGenConfigClient extends ClientBase {
    // All capture types with their active-version summary.
    async getTypes() {
        return await this.get(`${BASE_URL}/types`) ?? [];
    }

    // Version history for a type (newest first), active flagged.
    async getVersions(typeKey) {
        return await this.get(`${BASE_URL}/${typeKey}/versions`) ?? [];
    }

    // The active version for a type (parsed settings).
    async getActive(typeKey) {
        return await this.get(`${BASE_URL}/${typeKey}/active`);
    }

    // Save a new immutable version; request = { description, settings, activate }.
    async createVersion(typeKey, request) {
        return await this.post(`${BASE_URL}/${typeKey}/versions`, request);
    }

    // Make a version active (also how you revert to an earlier one).
    async activate(typeKey, rowKey) {
        return await this.post(`${BASE_URL}/${typeKey}/activate/${rowKey}`, {});
    }
}

export default new DualloModelGenConfigClient();
